module.exports = __webpack_public_path__ + "img/mailing.368c012f.gif";